import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import B2becButton from '@/components/B2becButton'
import { ProductService } from '@/services'
import { useAppSelector } from '@/store/hook'
import { selectIsProcurementTechnicalUserCxml } from '@/store/selectors/userSelector'
import { useAsync } from '@/hooks'
import useSessionBased from '@/hooks/useSessionBased'
import { ASYNC_STATUS } from '@/libs/constants'

const DisisHomeButton = () => {
  const { t } = useTranslation()
  const { sessionId } = useSessionBased()
  const isTechnicalUserCXML = useAppSelector(
    selectIsProcurementTechnicalUserCxml,
  )

  const sparePartsOpenMode = useMemo(
    () => (isTechnicalUserCXML ? '_self' : '_blank'),
    [isTechnicalUserCXML],
  )

  const getDisisHomePageURL = async () => {
    try {
      return ProductService.getDisisHomePageLink(sessionId)
    } catch (error) {
      console.error('Error fetching DISIS home page URL:', error?.message)
    }
  }

  const {
    execute: executeGetHomePageLink,
    value,
    status,
  } = useAsync(getDisisHomePageURL, false)

  const handleClick = (event) => {
    event.preventDefault()
    executeGetHomePageLink()
  }

  useEffect(() => {
    if (value) {
      const disisLink = value.data
      window.open(disisLink, sparePartsOpenMode, 'noopener noreferrer')
    }
  }, [value, sparePartsOpenMode])

  return (
    <div style={{ marginTop: '24px' }}>
      <a href="/#" rel="noopener noreferrer" target="_blank">
        <B2becButton
          ghost
          loading={status === ASYNC_STATUS.PENDING}
          onClick={handleClick}
        >
          {t('sparePartsFinder.button.toDisis')}
        </B2becButton>
      </a>
    </div>
  )
}

export default DisisHomeButton
